// src/components/Profile/UserWallet.js
import React from 'react';

const UserWallet = () => {
	// Static data for demonstration
	const walletData = {
		balance: 1250.75,
		currency: 'USD',
		transactions: [
			{ id: 1, date: '2023-10-15', description: 'Deposit from Bank', amount: 500.00, type: 'credit' },
			{ id: 2, date: '2023-10-10', description: 'Purchase - Premium Plan', amount: -29.99, type: 'debit' },
			{ id: 3, date: '2023-10-05', description: 'Refund - Cancelled Order', amount: 49.99, type: 'credit' },
			{ id: 4, date: '2023-10-01', description: 'Withdrawal to Bank', amount: -200.00, type: 'debit' },
			{ id: 5, date: '2023-09-28', description: 'Referral Bonus', amount: 10.00, type: 'credit' },
		]
	};

	return (
		<div className="bg-white rounded-lg shadow-sm p-6">
			<h2 className="text-2xl font-bold text-gray-800 mb-6">My Wallet</h2>

			{/* Balance Card */}
			<div className="bg-gradient-to-r from-blue-500 to-indigo-600 rounded-xl shadow-md p-6 text-white mb-8">
				<div className="flex justify-between items-start">
					<div>
						<p className="text-blue-100">Current Balance</p>
						<h3 className="text-3xl font-bold mt-2">
							{walletData.balance.toLocaleString('en-US', {
								style: 'currency',
								currency: walletData.currency
							})}
						</h3>
					</div>
					<div className="bg-white bg-opacity-20 p-2 rounded-lg">
						<svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
								d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
						</svg>
					</div>
				</div>

				<div className="flex mt-6 space-x-4">
					<button className="bg-white text-blue-600 hover:bg-blue-50 font-medium py-2 px-4 rounded-lg flex-1 text-center transition-colors">
						Add Funds
					</button>
					<button className="bg-blue-800 bg-opacity-50 hover:bg-opacity-70 text-white font-medium py-2 px-4 rounded-lg flex-1 text-center transition-colors">
						Withdraw
					</button>
				</div>
			</div>

			{/* Transaction History */}
			<div>
				<div className="flex justify-between items-center mb-4">
					<h3 className="text-lg font-semibold text-gray-700">Recent Transactions</h3>
					<button className="text-sm text-blue-600 hover:text-blue-800 font-medium">
						View All
					</button>
				</div>

				<div className="divide-y divide-gray-200">
					{walletData.transactions.map(transaction => (
						<div key={transaction.id} className="py-4 first:pt-0 last:pb-0">
							<div className="flex justify-between items-start">
								<div>
									<p className="font-medium text-gray-900">{transaction.description}</p>
									<p className="text-sm text-gray-500 mt-1">{transaction.date}</p>
								</div>
								<div className={`text-right font-medium ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`}>
									{transaction.amount > 0 ? '+' : ''}
									{transaction.amount.toLocaleString('en-US', {
										style: 'currency',
										currency: walletData.currency
									})}
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default UserWallet;